import { Injectable, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';

@Injectable({
    providedIn: 'root'
})
export class PaypalPayInThreeService {
    private sdkLoaded = false;
    private request = inject(RequestService);

    async load() {
        if (!this.sdkLoaded) {
            try {
                this.sdkLoaded = true;
                const result = await this.request.send(undefined, { path: 'paypal_button/config' }, undefined, undefined, {
                    method: 'GET'
                });
                await this.request.loadScript(result.sdkUrl);
            } catch (error) {
                this.sdkLoaded = false;
                throw error;
            }
        }
    }
}
